/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → reverse complement → GCAT.`)
};

const es_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → complemento inverso → GCAT.`)
};

const de_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → reverses Komplement → GCAT.`)
};

const nl_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → omgekeerd complement → GCAT.`)
};

const fr_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → complément inverse → GCAT.`)
};

const it_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → complemento inverso → GCAT.`)
};

const pt_br2_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → complemento reverso → GCAT.`)
};

const pt_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → complemento reverso → GCAT.`)
};

const ja_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → 逆相補配列 → GCAT。`)
};

const zh_revcomp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → 反向互补 → GCAT。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_ex1", locale)
	if (locale === "en") return en_revcomp_ex1(inputs)
	if (locale === "es") return es_revcomp_ex1(inputs)
	if (locale === "de") return de_revcomp_ex1(inputs)
	if (locale === "nl") return nl_revcomp_ex1(inputs)
	if (locale === "fr") return fr_revcomp_ex1(inputs)
	if (locale === "it") return it_revcomp_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_ex1(inputs)
	if (locale === "pt") return pt_revcomp_ex1(inputs)
	if (locale === "ja") return ja_revcomp_ex1(inputs)
	return zh_revcomp_ex1(inputs)
};